import Stack from '@mui/material/Stack';
import { SyntheticEvent, useEffect, useRef, useState } from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { SxProps, Theme } from '@mui/material/styles';
import Popper from '@mui/material/Popper';

interface ComponentProps {
  isDisabled?: boolean;
  label: string;
  open?: boolean;
  options: string[];
  sx?: SxProps<Theme>;
  onInputChange?: (value: string | null) => void;
  onSelectedOption?: (value: string) => void;
  onOpen?: () => void;
  onClose?: () => void;
}

export default ({
  isDisabled,
  label,
  open,
  options,
  sx,
  onInputChange,
  onSelectedOption,
  onOpen,
  onClose
}: ComponentProps) => {
  const [inputAutocomplete, setInputAutocomplete] = useState<string>('');

  const wrapperEl = useRef<HTMLDivElement>(null);

  const handleSelectedOptionAutocomplete = (
    event: SyntheticEvent<Element, Event>,
    value: string | null
  ) => {
    if (onSelectedOption) {
      onSelectedOption(value as string);
    }
  };

  const handleInputChangeAutocomplete = (
    event: SyntheticEvent<Element, Event>,
    input: string
  ) => {
    setInputAutocomplete(input);
    if (onInputChange) {
      onInputChange(input);
    }
  };

  useEffect(() => {
    if (open) {
      wrapperEl?.current?.querySelector('input')?.focus();
    } else {
      setInputAutocomplete('');
    }
  }, [open]);

  return (
    <Stack
      ref={wrapperEl}
      sx={{
        ...sx,
        backgroundColor: '#FFFFFF'
      }}
    >
      <Autocomplete
        handleHomeEndKeys
        // Issue: Unable to fix popper placement in autocomplete
        // Ref. https://stackoverflow.com/a/67435060
        // Force menu to open below, with the correct width
        PopperComponent={({ style, ...props }) => (
          <Popper
            {...props}
            style={{ ...style, height: 0 }} // width is passed in 'style' prop
          />
        )}
        // Set menu max height (optional)
        ListboxProps={{ style: { maxHeight: '30vh' } }}
        onChange={handleSelectedOptionAutocomplete}
        onInputChange={handleInputChangeAutocomplete}
        onOpen={onOpen}
        onClose={onClose}
        inputValue={inputAutocomplete}
        options={options}
        open={!isDisabled && open}
        renderInput={(params) => {
          return <TextField {...params} label={label} disabled={isDisabled} />;
        }}
        disabled={isDisabled}
      />
    </Stack>
  );
};
